<template>
  <div class="video-entry">
    <Button
      class='button'
      v-bind:class="{ entrySelected: collectionName === selectedEntry }"
      @click="sendlink(collectionTitle)"
    >
      <p class="collection-entry">
        <span
          class="provider-badge badge amazon_badge"
          v-if='selectedVodProvider === "amazon"'
        >
          {{ selectedVodProvider }}
        </span>

        <span
          class="provider-badge badge netflix_badge"
          v-if='selectedVodProvider === "netflix"'
        >
          {{ selectedVodProvider }}
        </span>

        <span
            class="provider-badge badge badge-success magenta_tv_badge"
            v-if='selectedVodProvider === "magenta_tv"'
        >
          Magenta TV
        </span>

        <span
            class="provider-badge badge badge-success joyn_badge"
            v-if='selectedVodProvider === "joyn"'
        >
          joyn
        </span>

        <span
                class="provider-badge badge badge-success disney_plus_badge"
                v-if='selectedVodProvider === "disney_plus"'
        >
          Disney+
        </span>

        <span
                class="provider-badge badge badge-dark"
                v-if='selectedVodProvider === "apple_tv_plus"'
        >
          Apple TV+
        </span>

        <span
          class="provider-badge badge badge-success"
          v-if='selectedVodProvider === "sky_ticket"'
        >
          sky Ticket
        </span>

        <span
          class="provider-badge badge tv-now_badge"
          v-if='selectedVodProvider === "tv_now"'
        >
          TV NOW
        </span>

        <span
                class="provider-badge badge badge-dark"
                v-if='selectedVodProvider === "itunes_video"'
        >
          iTunes Video
        </span>

        <span class="provider-badge badge google_play_badge"
            v-if='selectedVodProvider === "google_video" || selectedVodProvider === "google_play"'>
          Google Play
        </span>

        <span
          class="provider-badge badge maxdome_badge"
          v-if='selectedVodProvider === "maxdome"'
        >
          {{ selectedVodProvider }}
        </span>

        {{ collectionShortName }}

        <span
          class="badge badge-primary"
          v-if='exportTypes.includes("insert")'
        >
          New Data
        </span>

        <span
          class="badge badge-primary"
          v-if='exportTypes.includes("update")'
        >
          Update
        </span>

        <span
          class="badge badge-light"
          v-if='exportTypes.includes("text")'
        >
          Text
        </span>

      </p>

    </Button>
    <div class="devider"></div>
  </div>
</template>

<script>
import '../compiled-icons/star'
import axios from 'axios'
import { cacheAdapterEnhancer } from 'axios-extensions';

// enhance the original axios adapter with throttle and cache enhancer
const http = axios.create({
  baseURL: '/',
  adapter: cacheAdapterEnhancer(axios.defaults.adapter)
});

export default {
  name: 'Header',
  props: [
    'collectionName',
    'selectedEntry',
    'collectionTitle'
  ],
  data () {
    return {
      listEntry: this.collectionName.split('exported_data_')[1],
      selectedVodProvider: '',
      exportTypes: [],
      collectionShortName: ''
    }
  },
  mounted () {
    // console.log(' ========> getting provider of ' + this.collectionName.split(' ')[0])
    // let getProviderUrl = 'http://vod-qa-dashboard.mixd.tv:3000/getExportProviders' // /' + this.collectionName
    let getProviderUrl = this.$hostname + '/getExportProviders' // /' + this.collectionName

    this.collectionShortName = this.collectionName.split('_')[2].split('T')[0] + ' #' + this.collectionTitle.split('#')[1]
    // this.collectionShortName = this.collectionTitle //collectionName.split('_')[2].split('T')[0] + '#' + this.collectionName.split('#')[1]

    http.get(getProviderUrl).then(response => {
      for (let result of response.data.results) {
        if (result.collectionName === this.collectionName) {
          // console.log('FOUND', result.collectionName)
          this.selectedVodProvider = result.msg.provider
          this.exportTypes = result.msg.types
        }
      }
    })
  },
  watch: {
    collectionName: function (val) {
      this.collectionName = val
    }
  },
  methods: {
    sendlink: function (taitem) {
      this.$emit('selected-link', taitem)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-entry {
  color: #000;
  margin-bottom: 1px;
  display: flex;
}
.button{
  border: 0px;
  width: 100%
}
.button:hover {
  background-color: #aaa;
}
.provider-badge {
  width: 70px;
  height: 14px;
  font-size: 10px;
}
.magenta_tv_badge {
  background-color: magenta;
}
.joyn_badge {
  background-color: black;
  color: white;
}
.disney_plus_badge {
  background-color: navy;
  color: white;
}
.google_play_badge {
  background-color: #F9F9F9;
  color: #818386;
}
.tv-now_badge {
  background-color: #FABC2E;
}
.maxdome_badge {
  background-color: #24A1A7;
  color: white
}
.amazon_badge {
  background-color: #FA9901;
}
.netflix_badge {
  background-color: black;
  color: #D82026;
  font-weight: bolder;
}

.entrySelected {
  background-color: rgba(255,255,255,0.6);
  box-shadow: inset 0 0 1px #000000;
  border: 0px;
  margin: 0px;
  outline:0;
}
.collection-entry {
  text-transform: capitalize;
  text-align: left;
  padding-top: 3px;
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 0px;
  color: #333;
  font-size: 10px;
  font-weight: bold;
  max-height: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
}

.devider{
  height: 1px;
  margin-left: 0px;
  margin-right: 0px;
  background-color: #bbb;
}

</style>



// WEBPACK FOOTER //
// src/components/CollectionListEntry.vue